export interface ComicCategory {
  id: string;
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export interface ComicChapter {
  id: string;
  title: string;
  index: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  categories: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  followers: number;
  updatedAt: string;
  chapters: ComicChapter[];
  tags: string[];
}

export const comicCategories: ComicCategory[] = [
  { id: 'cat-1', name: '韩漫', slug: 'korean', icon: 'ri-global-line', description: '韩国漫画精选，画风精美剧情精彩' },
  { id: 'cat-2', name: '日漫', slug: 'japanese', icon: 'ri-earth-line', description: '日本经典漫画，题材丰富多样' },
  { id: 'cat-3', name: '国漫', slug: 'chinese', icon: 'ri-china-railway-line', description: '国产原创漫画，崛起中的东方力量' },
  { id: 'cat-4', name: '热血', slug: 'action', icon: 'ri-fire-line', description: '热血激斗，燃爆你的肾上腺素' },
  { id: 'cat-5', name: '恋爱', slug: 'romance', icon: 'ri-heart-line', description: '甜蜜浪漫，心动的恋爱故事' },
  { id: 'cat-6', name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', description: '奇幻冒险，探索未知的世界' },
  { id: 'cat-7', name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line', description: '悬疑推理，烧脑刺激的剧情' },
  { id: 'cat-8', name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', description: '爆笑日常，轻松解压的不二选择' },
  { id: 'cat-9', name: '都市', slug: 'urban', icon: 'ri-building-line', description: '都市生活，真实与幻想交织' },
  { id: 'cat-10', name: '古风', slug: 'historical', icon: 'ri-ancient-gate-line', description: '古风雅韵，穿越时空的故事' },
];

export const hotComics: Comic[] = [
  {
    id: 'comic-1',
    title: '反派千金的逆袭',
    author: '星光工作室',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20style%20manhwa%20cover%20art%20featuring%20an%20elegant%20female%20protagonist%20in%20a%20lavish%20Victorian%20gown%20with%20intricate%20lace%20details%2C%20dramatic%20lighting%20from%20a%20chandelier%2C%20rich%20warm%20golden%20and%20rose%20color%20palette%2C%20soft%20romantic%20atmosphere%2C%20digital%20illustration%20with%20painterly%20texture%2C%20clean%20background%20with%20ornate%20frame&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '穿越成为小说中的反派千金，她决定改写自己的命运。面对王室的阴谋、家族的背叛，她凭借智慧与勇气一步步走向权力的巅峰。一场华丽的逆袭即将上演！',
    categories: ['韩漫', '恋爱', '奇幻'],
    status: '连载中',
    rating: 9.6,
    views: 12800000,
    followers: 560000,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 87 }, (_, i) => ({
      id: `ch-comic-1-${i + 1}`,
      title: `第${i + 1}话`,
      index: i + 1,
      updatedAt: '2026-08-04',
    })),
    tags: ['穿越', '逆袭', '宫廷', '权谋'],
  },
  {
    id: 'comic-2',
    title: '剑道独尊',
    author: '墨染青衫',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Chinese%20manhua%20cover%20showcasing%20a%20powerful%20swordsman%20in%20flowing%20traditional%20hanfu%20robes%2C%20wielding%20a%20glowing%20sword%20amidst%20falling%20cherry%20blossoms%2C%20mountainous%20misty%20landscape%20background%2C%20dramatic%20composition%20with%20ink%20wash%20painting%20aesthetic%2C%20cool%20silver%20and%20jade%20green%20tones&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '少年林逸偶得剑道真传，从一介凡人踏上武道巅峰。修炼之路艰难险阻，强敌环伺，且看他如何一剑破万法，独尊剑道！',
    categories: ['国漫', '热血', '古风'],
    status: '连载中',
    rating: 9.4,
    views: 9600000,
    followers: 420000,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 156 }, (_, i) => ({
      id: `ch-comic-2-${i + 1}`,
      title: `第${i + 1}话`,
      index: i + 1,
      updatedAt: '2026-08-03',
    })),
    tags: ['修仙', '剑道', '热血', '成长'],
  },
  {
    id: 'comic-3',
    title: '甜蜜暴击',
    author: '棉花糖工坊',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20romance%20manga%20cover%20in%20Japanese%20shojo%20style%2C%20two%20teenagers%20sharing%20a%20tender%20moment%20under%20cherry%20blossom%20trees%2C%20soft%20pastel%20pink%20and%20cream%20color%20scheme%2C%20sparkling%20bokeh%20effects%2C%20gentle%20spring%20atmosphere%2C%20clean%20and%20dreamy%20illustration%20style&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '高冷校草遇上元气少女，一场误会引发的甜蜜恋爱。从互相看不顺眼到暗生情愫，校园里的每一个小细节都是心动的证据。',
    categories: ['日漫', '恋爱', '都市'],
    status: '已完结',
    rating: 9.3,
    views: 15200000,
    followers: 680000,
    updatedAt: '2026-07-28',
    chapters: Array.from({ length: 64 }, (_, i) => ({
      id: `ch-comic-3-${i + 1}`,
      title: `第${i + 1}话`,
      index: i + 1,
      updatedAt: '2026-07-28',
    })),
    tags: ['校园', '恋爱', '甜宠', '青春'],
  },
  {
    id: 'comic-4',
    title: '暗夜侦探',
    author: '夜语者',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20thriller%20manga%20cover%20with%20a%20detective%20in%20a%20trench%20coat%20standing%20in%20a%20rainy%20alley%20illuminated%20by%20a%20single%20streetlamp%2C%20noir%20atmosphere%2C%20deep%20blue%20and%20amber%20lighting%2C%20dramatic%20shadows%2C%20film%20noir%20inspired%20illustration%20with%20cinematic%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '连环凶案震惊全城，退役刑警韩夜重出江湖。每一起案件背后都隐藏着不为人知的秘密，真相远比想象的更加黑暗。悬疑推理的巅峰之作！',
    categories: ['韩漫', '悬疑', '都市'],
    status: '连载中',
    rating: 9.7,
    views: 8700000,
    followers: 390000,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 42 }, (_, i) => ({
      id: `ch-comic-4-${i + 1}`,
      title: `第${i + 1}话`,
      index: i + 1,
      updatedAt: '2026-08-04',
    })),
    tags: ['悬疑', '推理', '犯罪', '都市'],
  },
  {
    id: 'comic-5',
    title: '妖神记',
    author: '青云阁',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Chinese%20manhua%20cover%20depicting%20a%20mythical%20fox%20spirit%20with%20nine%20tails%20in%20an%20ethereal%20celestial%20palace%2C%20surrounded%20by%20floating%20lanterns%20and%20magical%20energy%2C%20vibrant%20jade%20green%20and%20gold%20color%20palette%2C%20intricate%20traditional%20Chinese%20art%20style%20with%20modern%20digital%20rendering&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '妖界与人界的平衡被打破，少年白泽觉醒上古妖神血脉。在这乱世之中，他必须做出选择——守护人类还是回归妖族？史诗级奇幻巨作！',
    categories: ['国漫', '奇幻', '古风'],
    status: '连载中',
    rating: 9.5,
    views: 11400000,
    followers: 510000,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 203 }, (_, i) => ({
      id: `ch-comic-5-${i + 1}`,
      title: `第${i + 1}话`,
      index: i + 1,
      updatedAt: '2026-08-03',
    })),
    tags: ['妖怪', '修仙', '史诗', '冒险'],
  },
  {
    id: 'comic-6',
    title: '办公室罗曼史',
    author: '蜂蜜柚子社',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20chic%20romance%20manhwa%20cover%20showing%20a%20stylish%20office%20setting%20with%20a%20handsome%20male%20lead%20in%20a%20tailored%20suit%20and%20a%20beautiful%20female%20lead%20near%20a%20coffee%20machine%2C%20warm%20ambient%20office%20lighting%2C%20modern%20Korean%20webtoon%20style%2C%20soft%20beige%20and%20mocha%20tones%2C%20clean%20professional%20aesthetic&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '职场小白林悦入职第一天就遇上了传说中的冷面上司。本以为要在地狱模式中苟且偷生，却发现这位上司私下里有着不为人知的温柔一面。',
    categories: ['韩漫', '恋爱', '都市'],
    status: '已完结',
    rating: 9.2,
    views: 10300000,
    followers: 450000,
    updatedAt: '2026-07-15',
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: `ch-comic-6-${i + 1}`,
      title: `第${i + 1}话`,
      index: i + 1,
      updatedAt: '2026-07-15',
    })),
    tags: ['职场', '恋爱', '甜宠', '总裁'],
  },
  {
    id: 'comic-7',
    title: '一拳超人外传',
    author: 'ONE工作室',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20action%20manga%20cover%20featuring%20a%20bald%20superhero%20with%20a%20yellow%20jumpsuit%20and%20red%20cape%20delivering%20a%20powerful%20punch%2C%20explosive%20impact%20effects%2C%20urban%20cityscape%20background%20being%20destroyed%2C%20bold%20red%20and%20yellow%20color%20scheme%2C%20classic%20Japanese%20manga%20action%20style%2C%20high%20energy%20composition&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '一拳就能解决所有敌人的最强英雄，却因为无敌而感到无聊。在外传中，探索英雄协会的其他S级英雄们的精彩故事！',
    categories: ['日漫', '热血', '搞笑'],
    status: '连载中',
    rating: 9.8,
    views: 21000000,
    followers: 920000,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: `ch-comic-7-${i + 1}`,
      title: `第${i + 1}话`,
      index: i + 1,
      updatedAt: '2026-08-04',
    })),
    tags: ['英雄', '战斗', '搞笑', '异能'],
  },
  {
    id: 'comic-8',
    title: '异世界料理人',
    author: '味觉工坊',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20charming%20Japanese%20isekai%20manga%20cover%20with%20a%20young%20chef%20holding%20a%20steaming%20bowl%20of%20ramen%20in%20a%20fantasy%20medieval%20kitchen%2C%20magical%20ingredients%20floating%20around%2C%20warm%20golden%20lighting%20from%20a%20hearth%2C%20cozy%20and%20appetizing%20atmosphere%2C%20detailed%20food%20illustration%20style&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '现代厨师穿越到异世界，用中华料理征服异世界人民的味蕾！麻婆豆腐、小笼包、火锅...一道道美食引发异世界的味觉革命。',
    categories: ['日漫', '搞笑', '奇幻'],
    status: '连载中',
    rating: 9.1,
    views: 7300000,
    followers: 310000,
    updatedAt: '2026-08-02',
    chapters: Array.from({ length: 95 }, (_, i) => ({
      id: `ch-comic-8-${i + 1}`,
      title: `第${i + 1}话`,
      index: i + 1,
      updatedAt: '2026-08-02',
    })),
    tags: ['穿越', '美食', '异世界', '搞笑'],
  },
];

export const latestUpdates: Comic[] = [
  {
    id: 'comic-9',
    title: '修仙狂潮',
    author: '九州书生',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20cultivation%20manhua%20cover%20with%20a%20young%20cultivator%20meditating%20on%20a%20floating%20mountain%20peak%2C%20aurora%20lights%20in%20the%20sky%2C%20spiritual%20energy%20swirling%20around%2C%20mystical%20purple%20and%20golden%20hues%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%20blended%20with%20modern%20digital%20art&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '末法时代，灵气复苏！普通大学生意外踏入修仙之路，在这个群雄并起的时代，看他一介凡人如何逆天改命，成就无上大道。',
    categories: ['国漫', '热血', '奇幻'],
    status: '连载中',
    rating: 9.0,
    views: 5400000,
    followers: 230000,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 318 }, (_, i) => ({
      id: `ch-comic-9-${i + 1}`,
      title: `第${i + 1}话 天劫降临`,
      index: i + 1,
      updatedAt: '2026-08-04',
    })),
    tags: ['修仙', '灵气复苏', '热血', '长篇'],
  },
  {
    id: 'comic-10',
    title: '魔女的条件',
    author: '极光漫画',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20manhwa%20cover%20with%20a%20mysterious%20witch%20in%20a%20black%20lace%20dress%20holding%20a%20glowing%20crystal%20orb%2C%20surrounded%20by%20enchanted%20rose%20vines%2C%20gothic%20mansion%20background%2C%20deep%20burgundy%20and%20midnight%20blue%20color%20scheme%2C%20elegant%20dark%20fantasy%20illustration&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '被诬陷为魔女的少女，在逃亡中觉醒真正的魔法力量。她发誓要向那些伤害过她的人复仇，一场黑暗华丽的魔法盛宴就此拉开帷幕。',
    categories: ['韩漫', '奇幻', '悬疑'],
    status: '连载中',
    rating: 9.3,
    views: 6100000,
    followers: 270000,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 55 }, (_, i) => ({
      id: `ch-comic-10-${i + 1}`,
      title: `第${i + 1}话`,
      index: i + 1,
      updatedAt: '2026-08-04',
    })),
    tags: ['魔法', '复仇', '黑暗', '女性向'],
  },
  {
    id: 'comic-11',
    title: '虎鹤双形',
    author: '武动乾坤',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20Chinese%20manhua%20cover%20showing%20two%20warriors%20in%20dynamic%20fighting%20poses%2C%20one%20using%20tiger%20style%20and%20one%20using%20crane%20style%2C%20dramatic%20ink%20splashes%2C%20traditional%20Chinese%20martial%20arts%20aesthetic%2C%20powerful%20black%20and%20white%20contrast%20with%20red%20accents%2C%20action-packed%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '虎拳与鹤拳两大门派的恩怨延续百年。当代传人为了武学真谛，必须放下门派之见，共同面对前所未有的危机。',
    categories: ['国漫', '热血', '古风'],
    status: '连载中',
    rating: 9.2,
    views: 4800000,
    followers: 200000,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 128 }, (_, i) => ({
      id: `ch-comic-11-${i + 1}`,
      title: `第${i + 1}话`,
      index: i + 1,
      updatedAt: '2026-08-04',
    })),
    tags: ['武术', '门派', '热血', '传承'],
  },
  {
    id: 'comic-12',
    title: '学院怪谈',
    author: '夜半钟声',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20horror%20manga%20cover%20set%20in%20an%20abandoned%20school%20corridor%20at%20night%2C%20a%20ghostly%20figure%20appearing%20at%20the%20end%20of%20the%20hallway%2C%20flickering%20fluorescent%20lights%2C%20eerie%20greenish%20tint%2C%20classic%20J-horror%20atmosphere%2C%20detailed%20background%20with%20lockers%20and%20posters&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '转学到古老学院的少年，发现这所学校隐藏着不为人知的秘密。每到午夜，走廊尽头就会传来诡异的脚步声...',
    categories: ['日漫', '悬疑', '都市'],
    status: '连载中',
    rating: 9.4,
    views: 6900000,
    followers: 300000,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 34 }, (_, i) => ({
      id: `ch-comic-12-${i + 1}`,
      title: `第${i + 1}话`,
      index: i + 1,
      updatedAt: '2026-08-03',
    })),
    tags: ['校园', '恐怖', '悬疑', '灵异'],
  },
];

export const completedComics: Comic[] = [
  {
    id: 'comic-13',
    title: '长歌行',
    author: '夏达',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20historical%20Chinese%20manhua%20cover%20depicting%20a%20princess%20in%20elaborate%20Tang%20dynasty%20robes%20riding%20a%20horse%20through%20a%20vast%20grassland%2C%20dramatic%20sunset%20sky%2C%20flowing%20silk%20ribbons%2C%20epic%20cinematic%20composition%2C%20traditional%20Chinese%20painting%20aesthetic%20with%20modern%20comic%20style&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    description: '大唐永宁公主李长歌，在玄武门之变后踏上逃亡之路。从草原到大漠，从长安到西域，一段波澜壮阔的历史传奇。荣获多项国内外漫画大奖！',
    categories: ['国漫', '古风', '热血'],
    status: '已完结',
    rating: 9.9,
    views: 35000000,
    followers: 1500000,
    updatedAt: '2025-12-20',
    chapters: Array.from({ length: 128 }, (_, i) => ({
      id: `ch-comic-13-${i + 1}`,
      title: `第${i + 1}话`,
      index: i + 1,
      updatedAt: '2025-12-20',
    })),
    tags: ['历史', '大唐', '冒险', '女性向'],
  },
  {
    id: 'comic-14',
    title: '完美世界',
    author: '辰东',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20epic%20fantasy%20manhua%20cover%20with%20a%20powerful%20young%20warrior%20standing%20atop%20a%20mountain%20of%20bones%2C%20holding%20a%20divine%20weapon%2C%20apocalyptic%20sky%20with%20crimson%20clouds%2C%20ancient%20ruins%20in%20the%20background%2C%20grand%20scale%2C%20mythological%20Chinese%20fantasy%20art%20style&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    description: '一粒尘可填海，一根草斩尽日月星辰。少年石昊为寻亲人踏入大荒，在万族林立的完美世界中，谱写一段不朽传说。',
    categories: ['国漫', '奇幻', '热血'],
    status: '已完结',
    rating: 9.7,
    views: 42000000,
    followers: 1800000,
    updatedAt: '2026-01-15',
    chapters: Array.from({ length: 256 }, (_, i) => ({
      id: `ch-comic-14-${i + 1}`,
      title: `第${i + 1}话`,
      index: i + 1,
      updatedAt: '2026-01-15',
    })),
    tags: ['玄幻', '修仙', '史诗', '热血'],
  },
  {
    id: 'comic-15',
    title: '她的私生活',
    author: '金作家',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20charming%20Korean%20romance%20manhwa%20cover%20with%20a%20professional%20woman%20secretly%20fangirling%20over%20idol%20merchandise%20in%20her%20room%2C%20colorful%20posters%20on%20the%20wall%2C%20cozy%20bedroom%20atmosphere%2C%20warm%20pink%20and%20cream%20tones%2C%20cute%20and%20relatable%20slice%20of%20life%20vibe&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    description: '完美职场女性成德美，私下却是一名狂热的偶像粉丝。当地下粉丝身份被美术馆馆长发现后，两人的关系发生了微妙的变化。',
    categories: ['韩漫', '恋爱', '都市'],
    status: '已完结',
    rating: 9.5,
    views: 18000000,
    followers: 780000,
    updatedAt: '2026-03-10',
    chapters: Array.from({ length: 88 }, (_, i) => ({
      id: `ch-comic-15-${i + 1}`,
      title: `第${i + 1}话`,
      index: i + 1,
      updatedAt: '2026-03-10',
    })),
    tags: ['职场', '恋爱', '偶像', '女性向'],
  },
  {
    id: 'comic-16',
    title: '斗破苍穹',
    author: '天蚕土豆',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20epic%20cultivation%20manhua%20cover%20showing%20a%20young%20man%20surrounded%20by%20colorful%20flames%2C%20holding%20a%20heavy%20black%20ruler%2C%20determined%20expression%2C%20phoenix%20silhouette%20in%20the%20background%2C%20intense%20orange%20and%20red%20energy%2C%20Chinese%20web%20novel%20adaptation%20art%20style&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后，突然一夜之间变成了废人。但他的命运，在遇见药老之后彻底改变。三十年河东，三十年河西，莫欺少年穷！',
    categories: ['国漫', '热血', '奇幻'],
    status: '已完结',
    rating: 9.6,
    views: 58000000,
    followers: 2500000,
    updatedAt: '2025-06-30',
    chapters: Array.from({ length: 320 }, (_, i) => ({
      id: `ch-comic-16-${i + 1}`,
      title: `第${i + 1}话`,
      index: i + 1,
      updatedAt: '2025-06-30',
    })),
    tags: ['玄幻', '修炼', '逆袭', '经典'],
  },
];

export const testimonials = [
  {
    id: 't-1',
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20man%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20warm%20indoor%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-t1&orientation=squarish',
    rating: 5,
    content: '奇妙漫画是我用过最好的漫画阅读平台！资源超级丰富，更新速度也很快。下拉式阅读体验非常流畅，不用一页页翻，太方便了！强烈推荐给所有漫画爱好者！',
    date: '2026-07-28',
  },
  {
    id: 't-2',
    name: '小透明',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20portrait%2C%20gentle%20smile%2C%20natural%20makeup%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20style&width=120&height=120&seq=avatar-t2&orientation=squarish',
    rating: 5,
    content: '在这里找到了很多冷门好漫画！分类做得特别好，找漫画超方便。而且全是免费的，追漫零压力。每天通勤路上必看，已经成了生活的一部分。',
    date: '2026-07-25',
  },
  {
    id: 't-3',
    name: '热血少年阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=A%20teenage%20Chinese%20boy%20portrait%2C%20energetic%20expression%2C%20sporty%20style%2C%20bright%20studio%20lighting%2C%20clean%20white%20background%2C%20youthful%20headshot%20style&width=120&height=120&seq=avatar-t3&orientation=squarish',
    rating: 4,
    content: '国漫区越来越强了！《完美世界》《斗破苍穹》这些大IP的漫画版做得太棒了。希望奇妙漫画能签下更多优质国漫作品，支持国产漫画崛起！',
    date: '2026-07-20',
  },
  {
    id: 't-4',
    name: '韩漫爱好者小美',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylish%20young%20Chinese%20woman%20portrait%2C%20fashionable%20look%2C%20confident%20smile%2C%20warm%20studio%20lighting%2C%20clean%20white%20background%2C%20modern%20headshot%20style&width=120&height=120&seq=avatar-t4&orientation=squarish',
    rating: 5,
    content: '韩漫的画风真的太精致了！奇妙漫画上的韩漫资源又多又新，翻译质量也很高。下拉式阅读简直就是为韩漫长条格式量身定做的，体验满分！',
    date: '2026-07-18',
  },
];

export const siteStats = {
  totalComics: 12580,
  totalChapters: 856000,
  dailyVisitors: 320000,
  registeredUsers: 2800000,
};

export const faqData = [
  {
    question: '奇妙漫画上的漫画都是免费的吗？',
    answer: '是的！奇妙漫画平台上的所有漫画作品均为免费阅读。我们致力于为广大漫画爱好者提供优质的免费阅读体验，无需付费即可畅享海量漫画资源。我们会通过广告等合法方式维持平台运营，绝不向读者收费。',
  },
  {
    question: '如何在手机端获得流畅的阅读体验？',
    answer: '奇妙漫画采用下拉式阅读设计，专为手机端优化。您只需在浏览器中打开我们的网站，选择喜欢的漫画，向下滑动即可连续阅读，无需翻页。我们建议使用Chrome或Safari浏览器以获得最佳体验。同时支持将网站添加到手机桌面，像App一样便捷使用。',
  },
  {
    question: '漫画更新的频率是怎样的？',
    answer: '不同漫画的更新频率有所不同。热门连载漫画通常保持每周1-2话的更新速度，部分作品甚至可以达到日更。您可以在每部漫画的详情页查看最新的更新时间和更新状态。我们建议定期访问网站或关注我们的社交媒体账号，第一时间获取更新通知。',
  },
  {
    question: '如何在奇妙漫画上找到想看的漫画？',
    answer: '我们有多种方式帮助您发现喜欢的漫画：1) 首页热门推荐展示了当前最受欢迎的漫画作品；2) 通过分类页面，您可以按韩漫、日漫、国漫或热血、恋爱、奇幻等类型筛选；3) 使用搜索功能输入漫画名称或关键词快速查找。',
  },
  {
    question: '奇妙漫画支持哪些类型的漫画？',
    answer: '奇妙漫画汇聚了韩漫、日漫、国漫三大类别的海量作品，涵盖热血、恋爱、奇幻、悬疑、搞笑、都市、古风等多种题材类型。无论您喜欢什么样的漫画风格，都能在这里找到心仪的作品。我们的内容团队每天都在持续扩充漫画库。',
  },
];